import React, { useState, useContext, useEffect } from 'react'
import { FormLogin } from './FormLogin'
import { doLogin } from './utils'
import { routes } from 'app/routes'
import { AuthenticationContext } from 'app/Contexts/AuthenticationProvider'
import { Text } from 'app/components/ui/Text'
import styled from 'styled-components'
import { Container } from 'app/components/ui/Container'
import { HeaderContext } from 'app/Contexts/HeaderProvider'
import { useHistory } from 'react-router-dom'
import { Base } from 'app/components/ui/Base'
import { themeEstra } from 'app/styles/themeEstra'
export const Login: React.FC = () => {
  const authCtx = useContext(AuthenticationContext)
  const headerCtx = useContext(HeaderContext)

  const { push } = useHistory()

  const goToDashboard = () => {
    push(routes.dashboard.makeUrl())
  }

  const [isDoingLogin, setIsDoingLogin] = useState(false)
  const [loginErrorMessage, setLoginErrorMessage] = useState<string | null>()

  const headerTitle = 'Area fornitori Marketing'
  const headerSubTitle = 'Accedi al servizio'
  const loginText =
    'Questa piattaforma gestisce le procedure di gestione dei preventivi richiesti dal Servizio Marketing e Comunicazione del gruppo Estra.\n' +
    '<b>Questa sezione del sito Estra NON è collegata alla selezione dei fornitori,</b> per cui è da intendersi privata e non aperta a candidature di aziende.\n\n'

  useEffect(() => {
    if (headerCtx) {
      headerCtx.updateTitles(headerTitle, headerSubTitle)
      headerCtx.updateSubtitleVariant('login_signup')
    }
  }, [])

  if (!authCtx || authCtx.loadingActor) {
    return null
  }

  if (authCtx && authCtx.actor && authCtx.actor.id && !isDoingLogin) {
    goToDashboard()
  }

  return (
    <Base
      paddingTop={0}
      bgImage='https://res.cloudinary.com/estra/image/upload/v1611226592/estra20dev/area_fornitori/login/login_text_bg.svg'
    >
      <Container>
        <Grid>
          <LoginTextColumn>
            <div>
              <Text
                variant='s20'
                color={themeEstra.color.primari.grigioEstra}
                dangerouslySetInnerHTML={{ __html: loginText }}
              ></Text>
              <Text variant='s20' color={themeEstra.color.primari.grigioEstra}>
                Per appalti e gare indette dal Gruppo Estra, accedi alla{' '}
                <a
                  href='https://www.estra.it/fornitori'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  pagina dedicata
                </a>
                .
              </Text>
            </div>
          </LoginTextColumn>

          {authCtx &&
          authCtx.actor &&
          authCtx.actor.id &&
          !isDoingLogin ? null : (
            <LoginFormColumn>
              <FormLogin
                onLoginRequest={({ email, password }) => {
                  setIsDoingLogin(true)
                  doLogin({
                    api_v1_user: {
                      email,
                      password,
                    },
                  })
                    .then(({ autorizationHeader, status, json }) => {
                      if (status === 200 && autorizationHeader && authCtx) {
                        // All good to go
                        authCtx.updateAuthToken(autorizationHeader)
                        goToDashboard()
                      } else {
                        // Login has failed
                        setLoginErrorMessage(json.error || 'Errore di login')
                        setIsDoingLogin(false)
                      }
                    })
                    .catch((error: Error) => {
                      // Login has failed
                      setLoginErrorMessage(error.message || 'Errore di login')
                      setIsDoingLogin(false)
                    })
                }}
                isLoading={isDoingLogin}
                errorMessage={loginErrorMessage}
              />
            </LoginFormColumn>
          )}
        </Grid>
      </Container>
    </Base>
  )
}

const Grid = styled.div`
  margin-bottom: 1rem;

  @media (min-width: ${({ theme }) => theme.bp.desktop}) {
    display: grid;
    grid-template-columns: 3fr 2fr;
    gap: 4rem;

    max-width: 1000px;

    margin-left: auto;
    margin-right: auto;
  }
`

const LoginTextColumn = styled(Text)`
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 4rem;

  display: flex;
  align-items: center;
`

const LoginFormColumn = styled.div`
  @media (max-width: ${({ theme }) => theme.bp.desktop}) {
    max-width: 340px;
    margin-left: auto;
    margin-right: auto;
  }
`
